import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AddSignerDialogueHandler } from './types';
import AddSignerContext from './AddSignerContext';

const { ConfirmationDialogue } = vp;

type AddSignerDialogueProps = {
  handleDialogue: DialogueHandler<AddSignerDialogueHandler>;
};

type FC = FunctionComponent<AddSignerDialogueProps>;

const AddSignerDialogue: FC = ({ handleDialogue }: AddSignerDialogueProps) => {
  const { showAddSignerFailError } = useContext(AddSignerContext);

  return useMemo(
    () => (
      <div>
        {/* Add Signer Error */}
        <ConfirmationDialogue
          isVisible={showAddSignerFailError}
          title="Error! The signer was not added."
          status="error"
          subTitle="Please provide valid address."
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showAddSignerFailError],
  );
};

export default AddSignerDialogue;
